import React from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import interiorImg from "../assets/cityhardwaredetroit.png";
import aisle001Img from "../assets/city-hardware-detroit-001.png";
import partsImg from "../assets/city-hardware-detroit-parts.png";
import "./PageStyles.css";
import "./AboutPage.css";

function AboutPage() {
  return (
    <div className="page">
      {/* Photo hero */}
      <div className="about-hero">
        <img
          src={interiorImg}
          alt="City Hardware interior — well-stocked aisles in Detroit"
          className="about-hero__bg"
        />
        <div className="about-hero__overlay" />
        <div className="container about-hero__content">
          <div className="page-hero__eyebrow">About Us</div>
          <h1 className="page-hero__heading">
            Built for
            <br />
            the City.
          </h1>
          <p className="page-hero__sub">
            City Hardware has been Detroit's neighborhood hardware store for
            over 35 years. Reliable supplies, trusted repairs, and practical
            expertise — every day.
          </p>
        </div>
      </div>

      {/* Story + stats */}
      <section className="page-section">
        <div className="container page-two-col">
          <div>
            <div className="section-eyebrow">Our Story</div>
            <h2 className="section-heading">
              Neighborhood Roots,
              <br />
              City Expertise.
            </h2>
            <p className="section-body">
              City Hardware opened its doors in Detroit in 1987 with a simple
              idea: give the community a fast, reliable, and well-stocked
              hardware store staffed by people who actually know their stuff.
            </p>
            <p className="section-body" style={{ marginTop: "1rem" }}>
              More than three decades later, that mission hasn't changed. We've
              helped thousands of Detroit homeowners, renters, contractors, and
              businesses find what they need — from a single bolt to a full
              window repair service.
            </p>
          </div>
          <div className="about-values">
            {[
              { label: "35+", sub: "Years Serving Detroit" },
              { label: "2,400+", sub: "Windows Repaired" },
              { label: "10,000+", sub: "Happy Customers" },
              { label: "7 Days", sub: "A Week, Open" },
            ].map((v) => (
              <div key={v.label} className="about-stat">
                <span className="about-stat__num">{v.label}</span>
                <span className="about-stat__label">{v.sub}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Store interior photos band */}
      <section className="about-photos-band">
        <div className="container about-photos-band__grid">
          <div className="about-photos-band__item about-photos-band__item--wide">
            <img
              src={aisle001Img}
              alt="City Hardware supply aisle"
              className="about-photos-band__img"
            />
            <div className="about-photos-band__caption">
              Stocked for every project
            </div>
          </div>
          <div className="about-photos-band__item">
            <img
              src={partsImg}
              alt="City Hardware fasteners and hardware wall"
              className="about-photos-band__img"
            />
            <div className="about-photos-band__caption">
              200+ fastener options
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="page-section page-section--gray">
        <div className="container">
          <div className="section-eyebrow">Our Values</div>
          <h2 className="section-heading">How We Show Up.</h2>
          <div className="three-col-grid">
            {[
              {
                title: "Reliable",
                body: "You can count on us. We stock what you need, we know the answers, and we follow through.",
              },
              {
                title: "Capable",
                body: "Experienced, skilled, and solution-oriented. We approach every repair and every question with real expertise.",
              },
              {
                title: "Local",
                body: "Detroit through and through. We care about this city and the people who live and work here.",
              },
            ].map((c) => (
              <div key={c.title} className="info-card">
                <h3 className="info-card__title">{c.title}</h3>
                <p className="info-card__body">{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page-cta-band">
        <div className="container page-cta-band__inner">
          <div>
            <h2 className="page-cta-band__heading">Stop In and Say Hello.</h2>
            <p className="page-cta-band__sub">
              16325 W Warren Ave, Detroit, MI 48228 · Mon–Fri 9AM–6PM · Sat
              9AM–5PM
            </p>
          </div>
          <div className="page-cta-band__actions">
            <a href="tel:+13135828860" className="btn btn--red">
              <Phone size={16} /> (313) 582-8860
            </a>
            <Link to="/contact" className="btn btn--outline-black">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
